module.exports = __webpack_public_path__ + "img/pickUpBar.67609acd.svg";